<script setup lang="ts">
import { RouterView } from 'vue-router'

import { Toaster } from '@/ui'
</script>

<template>
  <RouterView />
  <Toaster />
</template>
